// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// load fonts
// WebFont.load({
//     google: { // add &display=swap to end of ONLY END font family, not every single one, other it doesnt load those fonts after
//         families: ['Plus+Jakarta+Sans:wght@400;600&display=swap']
//     },
//     //,
//     // typekit: {
//     // id: 'XXXX'
//     // },
//     active: function() { // helps stop flash of unstyled text
//         sessionStorage.fontsLoaded = true
//     }
// });

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('select2/dist/js/select2.full.min');
require('@accessible360/accessible-slick/slick/slick.min');

//Load Modules
require('./modules/accordion');
require('./modules/formInputs');
require('./modules/videoButtonReplacer');
require('./modules/videoPopup');
require('./modules/menu');
require('./modules/tabs');
require('./modules/global');
require('./modules/slider');
require('./modules/filters');
